import decode from 'jwt-decode'

export const isTokenExpired = (token: string) => {
  if (token) {
    const decodedToken: any = decode(token)
    if (!decodedToken.exp) {
      return null
    }
    const date = new Date(0)
    const expiringDate = date.setUTCSeconds(decodedToken.exp)
    const now = Date.now()
    return expiringDate < now
  }
}
